module.exports = __webpack_public_path__ + "media/6.40baa9c1.mp3";